import React from 'react';

interface Capability {
  index: string;
  title: string;
  summary: string;
  points: string[];
}

const capabilities: Capability[] = [
  {
    index: '01',
    title: 'Systems',
    summary:
      'System design and data flow.',
    points: ['System design', 'Data flow', 'Testing'],
  },
  {
    index: '02',
    title: 'Software',
    summary:
      'Python, React, computer vision, and web tools.',
    points: ['Python and React', 'Computer vision', 'Web tools'],
  },
  {
    index: '03',
    title: 'Automation',
    summary:
      'Python scripts for repetitive tasks.',
    points: ['Python scripts', 'Data work', 'Integrations'],
  },
  {
    index: '04',
    title: 'Hardware',
    summary:
      'CAD, 3D printing, electronics, and firmware.',
    points: ['Fusion 360 and CAD', '3D printing', 'Electronics and firmware'],
  },
];

const Capabilities: React.FC = () => {
  return (
    <section className="capabilities section" id="capabilities">
      <div className="container">
        <div className="section-head">
          <p className="section-head__kicker">What I do</p>
          <h2 className="section-head__title">
            Investigate. Build. Repeat.
          </h2>
          <p className="section-head__lede">
            Software, automation, computer vision, electronics, and CAD. Two years of SOC
            experience with log analysis, investigations, and Python tools.
          </p>
        </div>

        <div className="capabilities__grid">
          {capabilities.map(capability => (
            <article className="capability" key={capability.index}>
              <span className="capability__index">{capability.index}</span>
              <h3 className="capability__title">{capability.title}</h3>
              <p className="capability__summary">{capability.summary}</p>
              <ul className="capability__list">
                {capability.points.map(point => (
                  <li className="capability__item" key={point}>
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Capabilities;